import { monitor, MonitorEvent } from '@/services/monitor';
import {
  OPTIMIZER_GA_EVENT_CONFIG,
  ProductOptimizerEvent,
  resolveOptimizerPopId,
} from './gaTracking';
import { StrategyId } from './types';

export type OptimizerEvent =
  | 'form_optimizer_recommendation_impression'
  | 'form_optimizer_recommendation_applied'
  | 'form_optimizer_recommendation_apply_failed'
  | 'form_optimizer_recommendation_dismissed'
  | 'form_optimizer_recommendation_undone'
  | 'form_optimizer_recommendation_parse_failed';

function parseLocalStorageItem(key: string): Record<string, unknown> {
  try {
    return JSON.parse(localStorage.getItem(key) || '{}');
  } catch (_) {
    return {};
  }
}

function isProductOptimizerEvent(eventName: OptimizerEvent): eventName is ProductOptimizerEvent {
  return eventName in OPTIMIZER_GA_EVENT_CONFIG;
}

function reportGoogleAnalyticsEvent(
  eventName: ProductOptimizerEvent,
  strategyId: StrategyId,
  evidenceVersion: string,
  extra: Record<string, unknown>
): void {
  const config = OPTIMIZER_GA_EVENT_CONFIG[eventName];
  const companyInfo = parseLocalStorageItem('companyInfo');
  const displayInfo = parseLocalStorageItem('displayInfo');
  const { popId: suppliedPopId, ...eventExtra } = extra;

  (window as any).gtagNew?.('event', config.eventName, {
    event_name: config.eventLabel,
    event_type: config.eventType,
    Company_id: companyInfo.id,
    login_id: displayInfo.id,
    login_type: displayInfo.innerUserType,
    path_url: window.location.href,
    time: new Date(),
    popId: suppliedPopId ?? resolveOptimizerPopId(window.location.pathname),
    strategyId,
    evidenceVersion,
    ...eventExtra,
  });
}

export function reportFormOptimizerEvent(
  eventName: OptimizerEvent,
  strategyId: StrategyId,
  evidenceVersion: string,
  extra: Record<string, unknown> = {}
): void {
  if (isProductOptimizerEvent(eventName)) {
    reportGoogleAnalyticsEvent(eventName, strategyId, evidenceVersion, extra);
    return;
  }

  // 解析失败、应用失败等技术事件继续进入 SLS，不与 GA 产品埋点混用。
  monitor({
    event: MonitorEvent.Function,
    function: eventName,
    file: 'wheelOfFortune/pop/optimizer',
    data: { strategy_id: strategyId, evidence_version: evidenceVersion, ...extra },
  });
}
